<template>
  <b-row class="px-lg-2 px-4">
    <b-col cols="12" class="mb-4">
      <b-modal
        v-model="open"
        :title="`${title} Serviço`"
        size="lg"
        header-bg-variant="orange"
        header-text-variant="light"
        centered
        hide-footer
        no-close-on-backdrop
      >
      <b-row class="mt-3">
        <b-col cols="12">
          <label>Nome:</label>
          <b-form-input
            v-model="fields.name"
            placeholder="Nome do serviço"
            trim
          ></b-form-input>
        </b-col>
        <b-col cols="12" lg="4" class="mt-3">
          <label>Preço:</label>
          <InputMoney
            v-model="fields.price"
          />
        </b-col>
        <b-col cols="12" lg="4" class="mt-3">
          <label>Garantia em meses:</label>
          <b-form-input
            v-model="fields.service_guarantee"
            type="number"
            v-mask="['#','##']"
            placeholder="Ex: 12"
            trim
          ></b-form-input>
        </b-col>
        <b-col cols="12" lg="4" class="mt-3">
          <label>Prazo de instalação médio em horas:</label>
          <span>
            <i
              class="fas fa-question-circle question-tool-tips"
              id="deadline"
            ></i>
              <b-tooltip target="deadline">
                Tempo medio que levará para realização do serviço no cliente!
            </b-tooltip>
          </span>
          <b-form-input
            v-model="fields.deadline"
            placeholder="Ex: 3"
            type="number"
            v-mask="['#','##']"
            trim
          ></b-form-input>
        </b-col>
        <b-col cols="12" class="mt-3">
          <label>Tipo de Serviço:</label>
          <b-form-select
            :options="options"
            v-model="fields.type"
            placeholder="Descrição dos tipos de serviços"
            trim
          ></b-form-select>
        </b-col>
        <b-col cols="12" class="mt-3">
          <label>Serviços inclusos:</label>
          <b-form-textarea
            v-model="fields.services_included"
            placeholder="Descrição dos serviços inclusos"
            rows="3"
            max-rows="8"
            maxLength="1000"
          ></b-form-textarea>
        </b-col>
        <b-col cols="12" class="mt-3">
          <label>Serviços não inclusos:</label>
          <b-form-textarea
            v-model="fields.services_not_included"
            placeholder="Descrição do que não esta incluso no serviço"
            rows="3"
            max-rows="8"
            maxLength="1000"
          ></b-form-textarea>
        </b-col>
        <b-col cols="12" class="mt-3">
          <label>Preparação para Instalação:</label>
          <b-form-textarea
          v-model="fields.prepare_installation"
            placeholder="Descrição do que deve estar pronto para realizar a instalação"
            rows="3"
            max-rows="8"
            maxLength="1000"
          ></b-form-textarea>
        </b-col>
        <b-col cols="12" md="6" class="d-flex justify-content-end mt-5">
          <b-button
            variant="danger"
            block
            @click="open = false"
          >
          Cancelar
          </b-button>
        </b-col>
        <b-col cols="12" md="6" class="d-flex justify-content-end mt-5">
          <b-button
          v-if="isNew"
            variant="success"
            block
            @click="save()"
          >
          Salvar
          </b-button>
          <b-button
          v-else
            variant="success"
            block
            @click="update()"
          >
          Atualizar
          </b-button>
        </b-col>
      </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import makeToast from 'Mixins/makeToast';
import TypeServices from '@/enums/TypeServices';
import InputMoney from 'Components/Inputs/InputMoney.vue';

export default {
  mixins: [makeToast],
  emits:['newService', 'updateService'],

  components: {
    InputMoney
  },

  data() {
    return {
      loading: false,
      open: false,
      title: '',
      isNew: true,
      fields: {
        construp_user_id: '',
        name: '',
        type: TypeServices.INSTALACAO,
        price: '',
        deadline: '',
        uf_state: '',
        services_included: '',
        services_not_included: '',
        prepare_installation: '',
        service_guarantee: 0,
      },
      options: [
        { value: null, text: 'Selecione o tipo de serviço' },
        { value: TypeServices.INSTALACAO, text: 'Instalação' },
      ]
    }
  },

  methods: {
    toggleOpen({ data = [], isNew = true}) {
      this.open = !this.open;
      this.cleanFields();
      this.fields = data;
      this.fields.type = TypeServices.INSTALACAO;
      this.title = !isNew ? 'Editar' : 'Cadastrar Novo';
      this.isNew = isNew;
    },
    cleanFields() {
      this.fields.name = '';
      this.fields.type = '';
      this.fields.price = '';
      this.fields.deadline = '';
      this.fields.uf_state = '';
      this.fields.services_included = '';
      this.fields.services_not_included = '';
      this.fields.prepare_installation = '';
      this.fields.service_guarantee = 0;
    },
    save() {
      if(!this.validateForm()) return;
      this.formatMoney();
      this.$emit('newService', this.fields);
      this.open = !this.open;
    },
    formatMoney() {
      const money = this.fields.price.replace('R$','');
      this.fields.price = money.replace(',', '.');
    },
    update() {
      if(!this.validateForm()) return;
      this.formatMoney();
      this.$emit('updateService', this.fields);
      this.open = !this.open;
    },
    validateForm() {
      if(!this.fields.name) {
        this.makeToast(
          'Erro',
          'O nome do serviço não pode ser vazio!',
          'danger'
        );
        return false;
      }

      if(!this.fields.price) {
        this.makeToast(
          'Erro',
          'O preço do serviço não pode ser vazio!',
          'danger'
        );
        return false;
      }
      
      if(!this.fields.service_guarantee) {
        this.makeToast(
          'Erro',
          'A garantia do serviço não pode ser vazio!',
          'danger'
        );
        return false;
      }

      if(!this.fields.deadline) {
        this.makeToast(
          'Erro',
          'O prazo de instalação do serviço não pode ser vazio!',
          'danger'
        );
        return false;
      }

      if(!this.fields.type || this.fields.type !== TypeServices.INSTALACAO) {
        this.makeToast(
          'Erro',
          'O tipo do serviço não pode ser vazio!',
          'danger'
        );
        return false;
      }
      return true;
    }
  }
}
</script>
